import React, { LegacyRef, forwardRef } from 'react';

import { RoundButton } from '../RoundButton';
import { View } from 'react-native';

const donateImage = require('assets/donation.svg');

export const DonationButton = forwardRef((props, ref: LegacyRef<View>) => (
  <View ref={ref}>
    <RoundButton
      url={
        'https://quoguewildliferefuge.org/get-involved/become-a-member-today/'
      }
      image={donateImage}
      color={'#e1e126'}
    />
  </View>
));
